import { ReactNode } from 'react';

interface SectionHeaderProps {
  kicker: string;
  title: string;
  lead?: ReactNode;
  align?: 'center' | 'left';
}

const SectionHeader = ({ kicker, title, lead, align = 'center' }: SectionHeaderProps) => (
  <div className={`mb-12 md:mb-14 max-w-3xl ${align === 'center' ? 'text-center mx-auto' : ''}`}>
    <p className="eyebrow mb-3">{kicker}</p>
    <h2 className="heading text-3xl sm:text-4xl md:text-5xl mb-5">{title}</h2>
    {lead && <p className={`lead max-w-2xl ${align === 'center' ? 'mx-auto' : ''}`}>{lead}</p>}
  </div>
);

export default SectionHeader;
